module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/post-type-12-9f18a37ec87c7c0cd8ff2219ff01b404.png";